import { render, staticRenderFns } from "./AppFromGroupSelectable.vue?vue&type=template&id=196a727e"
import script from "./AppFromGroupSelectable.vue?vue&type=script&lang=js"
export * from "./AppFromGroupSelectable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports